export class CalendarInfo {
  start: string;
  end: string;
  id: number;
  accountingPeriodId: number;
  subtype: string;
  year: string;
  title: string;
  period: number;
}
